<template>
    <v-app class="bgImage">
        <m-errorbox ref="errorBox"></m-errorbox>
        <navbar />
        <v-content class="secondary--text text--darken-2">
            <v-container fluid class="fill-height">
                <v-card width="100%" class="fill-height">
                    <v-card-actions>
                        <v-col class="d-flex" cols="12" sm="6">
                        <v-select
                            v-model="testLevel"
                            :items="testLevels"
                            label="Test Level"
                            ></v-select>
                        </v-col>
                        <v-col class="d-flex" cols="12" sm="1">
                            <v-btn @click="onRunTest">Run Test</v-btn>
                        </v-col>
                        <v-col class="d-flex" cols="12" sm="3">
                            <v-btn @click="onResetFileSystem">Reset Flash File System</v-btn>
                        </v-col>
                        <v-col class="d-flex" cols="12" sm="2">
                            <v-btn @click="onClearFlash">Clear Flash Files</v-btn>
                        </v-col>
                    </v-card-actions>
                    <v-card-text>
                        <p v-if="results.length > 0" class="display-1 text--primary" style="text-transform:uppercase;">
                            Results
                        </p>
                        <p v-for="(result, index) in results" :key="index" style="font-family:monospace;" class="my-0 py-0" v-html="result">
                        </p>
                    </v-card-text>
                </v-card>
            </v-container>
        </v-content>
    </v-app>
</template>

<script>
import usbRequest from '../mixins/usb-request';

function buf2Hex(buffer) { // buffer is an ArrayBuffer
  return Array.prototype.map.call(new Uint8Array(buffer), x => ('00' + x.toString(16)).slice(-2)).join('').toUpperCase();
}

function hex2buf(strHex){
    // handle empty string
    if (! strHex) return []

    strHex = cleanHexString(strHex);

    return strHex.match(/[\da-f]{2}/gi).map(function (h) {
        return parseInt(h, 16)
    });
}

function cleanHexString(hexStr){
    return hexStr.replace(/[^a-fA-F0-9]/g,''); // remove any non-hex characters.
}

function hexLen(hexStr){
    return cleanHexString(hexStr).length / 2;
}

function ascToHex(ascStr){
    var hex, i;
    var result = "";
    for (i=0; i<ascStr.length; i++) {
        hex = ascStr.charCodeAt(i).toString(16);
        //result += ("000"+hex).slice(-4); // for unicode
        result += ("00"+hex).slice(-2); // for ascii
    }
    return result
}

function arraysEqual(arr1, arr2){
    if (arr1.length != arr2.length){
        return false;
    }

    for (var i = 0; i<arr1.length; i++){
        if (arr1[i] != arr2[i]){
            return false;
        }
    }
    return true;
}

function createRandomArray(length){
    var result = []
    for (var i = 0; i<length; i++){
        result.push(Math.floor(Math.random()*256))
    }
    return result;
}

function createIncrementalArray(length){
    var result = []
    for (var i = 0; i<length; i++){
        if (i%2){
            //odd(1,3)
            result.push(Math.floor(i/256)%256); //MSB
        } else {
            //even(0,2)
            result.push(i%256); //LSB
        }
    }
    return result;
}


function randomInt(max, min = 0){
    return Math.floor(Math.random()*(max-min)) + min
}

export default {
    mixins:[usbRequest],
    data() {
        return {
            results:[],
            hasFail:false,
            blockErrors:false,
            errorThrown:false,

            // test level definitions
            testLevels:[
                "Connection Test",
                "Quick Flash Memory Test",
                "Full Flash Memory Test",
            ],
            testLevel:"Connection Test", // the test levels that will be executed
        };
    },
    mounted(){

        //this.usbRequest('device', this.$route.params.id).then(r=>console.log(r));
    },
    methods:{
        showError(message){
            if (! this.blockErrors){
                this.$refs.errorBox.showError(message);
            } else {
                this.errorThrown = true;
            }
        },
        log(strVal){

            //this.results.push(strVal);
        },

        // returns command response on FAIL, and false on PASS
        async doTest(command, payload, expect, timeout){
            expect = cleanHexString(expect);
            payload = cleanHexString(payload);
            let res = await this.deviceRequest(command, hex2buf(payload), {timeout})
            return buf2Hex(res) !== expect ? buf2Hex(res) : false;
        },
        pushTestText(text, isPass){
            let width = 80
            if (isPass === true){
                this.results.push( text.padEnd(width, ".") + `<span class="pass mdi mdi-check"> Pass.</span>` );
            } else if (isPass === false){
                this.results.push( text.padEnd(width, ".") + `<span class="fail mdi mdi-close-octagon"> Fail.</span>` );
            } else {
                this.results.push( text.padEnd(width, ".") + `<span class="wait mdi mdi-timer-sand"> Wait.</span>` );
            }
        },
        async printTest(level, title, func, args, expect, progressMessage){

            let testIndex = this.testLevels.indexOf(level);
            if (testIndex == -1) throw "Unkown test level index in printTest";
            if (this.testLevels.indexOf(this.testLevel) < testIndex) return;

            if (this.hasFail) return;

            if (progressMessage){
                this.pushTestText(progressMessage)
            } else {
                this.pushTestText(title)
            }

            let result;

            try{
                result = await func(...args)
            } catch(ex) {
                this.pushTestText("title", false)
                this.results.push(`<span class="fail">Exception:"${ex}"</span>`);
                this.hasFail = true;
                this.errorThrown = false;
                return;
            }

            this.results.pop()

            if (expect === undefined){
                this.pushTestText(title, true);
                return result;
            } else if (Array.isArray(result) && typeof(expect) == "string") {
                expect = cleanHexString(expect)
                result = buf2Hex(result)
            } else if (Array.isArray(expect) && Array.isArray(result)) {
                expect = buf2Hex(expect)
                result = buf2Hex(result)
            }

            this.pushTestText(title, result === expect)
            if (result !== expect){
                this.hasFail = true;
                this.results.push("");

                let expectHtml = expect;
                let resultHtml = result;
                if (typeof(results) === typeof(expect) === "string"){

                    expectHtml = ""
                    resultHtml = ""
                    let okState = true;
                    for (let i=0;i<expect.length; i++){
                        if ((expect.charAt(i) == result.charAt(i)) != okState){
                            okState = (expect.charAt(i) == result.charAt(i));
                            if (okState){
                                expectHtml += `</span>`
                            } else {
                                expectHtml += `<span style="background:yellow;">`
                            }
                        }
                        expectHtml += expect.charAt(i);
                    }
                    if (!okState){
                        expectHtml += `</span>`
                    }
                    okState = true;
                    for (let i=0;i<result.length; i++){
                        if ((expect.charAt(i) == result.charAt(i)) != okState){
                            okState = (expect.charAt(i) == result.charAt(i));
                            if (okState){
                                resultHtml += `</span>`
                            } else {
                                resultHtml += `<span style="background:yellow;">`
                            }
                        }
                        resultHtml += result.charAt(i);
                    }
                    if (!okState){
                        resultHtml += `</span>`
                    }
                }

                this.results.push(`<span class="fail">Expected = "${expectHtml}"</span>`);
                this.results.push(`<span class="fail">Got ====== "${resultHtml}"</span>`);
            } else if ((result === false) != (expect === false)) {
                this.hasFail = true;
                if (result === false){
                    this.pushTestText("The last test reported a USB error, when it should not have", false)
                } else {
                    this.pushTestText("The last test should have reported a USB error, but did not", false)
                }
            }
            this.errorThrown = false;

        },
        async writeDataToFile(msg, fileData){
            let numBlocks = Math.ceil(fileData.length/256)
            for (let i = 0; i < fileData.length; i += 256){
                var blockSize = Math.min(256, fileData.length - i)
                if(this.hasFail) {
                    break;
                } else {
                    this.results.pop()
                    await this.printTest(msg + "(Writing block " + (i/256+1) + " of " + numBlocks + ")",this.usbWriteFile, [fileData.slice(i, i+blockSize)], true);
                }
            }
        },
        async compareDataWithFile(msg, fileData, fileNumber){
            // data is read in 1K blocks (instead of 256 byte)because the
            // output buffer on the logger is much
            // larger than the input buffer.
            let numBlocks = Math.ceil(fileData.length/1024)
            for (let i = 0; i < fileData.length; i += 1024){
                var blockSize = Math.min(1024, fileData.length - i)
                if(this.hasFail) {
                    break;
                } else {
                    this.results.pop()
                    await this.printTest(msg + "(Comparing block " + (i/1024+1) + " of " + numBlocks + ")",this.usbReadFile,[fileNumber, i, blockSize], fileData.slice(i, i+blockSize));
                }
            }
        },
        async createAndVerifyFiles(title, creationList, optionsArg){

            // this function is only ever part of a full flash test.
            let testIndex = this.testLevels.indexOf("Full Flash Memory Test");
            if (testIndex == -1) throw "Unkown test level index in createAndVeriryFiles";
            if (this.testLevels.indexOf(this.testLevel) < testIndex) return;

            if (this.hasFail) return;

            var options = Object.assign({
                localStorageKey:false, // specifying this will store the file data to local storage, or retreive the same data for comparison if it exists
                incremental:false, // this will use incremental data, instead of random data to fill the file
                indicesToTest:Array.from(creationList.keys()), // this will limit the comparison to the indices in the array.
                byteSizeToCompare:[], // this will limit the number of bytes compared in the file.
            }, optionsArg);

            // create and verify files to test the file system driver

            var fileList;
            // if a localStorageKey is specified, and exists, do not create
            // the files, just validate them.
            if ( options.localStorageKey && localStorage.getItem(options.localStorageKey) !== null ) {
                fileList = JSON.parse(localStorage.getItem(options.localStorageKey));
            } else {

                this.pushTestText("Create and test " + creationList.length + " files");
                fileList = [];
                for (let i = 0; i< creationList.length; i++){
                    if(this.hasFail) {
                        break;
                    } else {
                        let msg = "Creating test file " + (i+1) + " of " + creationList.length + " (" + (creationList[i] / 1024).toFixed(2) + "KB)"
                        let filesize = creationList[i];
                        let fileContent;
                        if (options.incremental){
                            fileContent = createIncrementalArray(filesize)
                        } else {
                            fileContent = createRandomArray(filesize)
                        }

                        this.results.pop()

                        await this.printTest(msg + " (Open file)",this.usbOpenFile, [], true);
                        this.results.pop()
                        let fileNumber = await this.printTest(msg + "(Get file number)",this.usbGetFileNumber, []);
                        console.log("File number: ", fileNumber, " Size: ", filesize);
                        fileList.push([fileNumber, fileContent]);
                        await this.writeDataToFile(msg, fileContent);
                    }
                }

                if (options.localStorageKey){
                    localStorage.setItem(options.localStorageKey, JSON.stringify(fileList));
                }
            }

            // check that the file content matches what we intended it to be
            for (let i = 0; i< options.indicesToTest.length; i++){
                let index = options.indicesToTest[i];
                if(this.hasFail) {
                    break;
                } else {
                    let contentToCompare  = fileList[index][1];
                    if (options.byteSizeToCompare[index] !== undefined){
                        console.log("Comparing partial content " + options.byteSizeToCompare[index] + " of " + fileList[index][1].length + " bytes.")
                        contentToCompare = contentToCompare.slice(0, options.byteSizeToCompare[index]);
                    }
                    await this.compareDataWithFile("Comparing file " + i + " of " + fileList.length + " ", contentToCompare, fileList[index][0]);
                }
            }

            // leave the title as the final text on the report.
            if(! this.hasFail) {
                this.results.pop();
                this.pushTestText(title, true);
            }
        },
        async onRunTest(evt){

            this.hasFail = false; // clear flag so that tests are actually completed.
            this.results = []
            this.blockErrors = true; // do not display the error box during testing.

            try{
                await this.printTest("Connection Test", "Get token",this.usbGetToken, [], this.$route.params.id);



                await this.printTest("Full Flash Memory Test", "Initial memory erase before testing", this.usbResetFileSystem, [], true, "Clearing the flash memory takes 30 seconds, please wait");
                await this.printTest("Quick Flash Memory Test", "Memory read to check erased",this.usbReadFlash, [256,16], "FFFF FFFF FFFF FFFF FFFF FFFF FFFF FFFF");
                var testData = hex2buf("01 00 03 02 05 04 07 06")
                await this.printTest("Quick Flash Memory Test", "Bad memory write, spans page boundary",this.usbWriteFlash, [509, testData], false);
                await this.printTest("Quick Flash Memory Test", "Memory read to check bad write did not proceed",this.usbReadFlash, [509, 16], "FFFF FFFF FFFF FFFF FFFF FFFF FFFF FFFF");
                await this.printTest("Quick Flash Memory Test", "Good memory write",this.usbWriteFlash, [256, testData], true);
                await this.printTest("Quick Flash Memory Test", "Memory read to check good write occured",this.usbReadFlash, [256, testData.length], testData);

                await this.printTest("Quick Flash Memory Test", "Memory erase not on boundary",this.usbEraseFlash, [256], false);
                await this.printTest("Quick Flash Memory Test", "Verify memory erase not on boundary did not occur",this.usbReadFlash, [256, testData.length], testData);
                await this.printTest("Quick Flash Memory Test", "Memory erase",this.usbEraseFlash, [0], true);
                await this.printTest("Quick Flash Memory Test", "Verify memory erased",this.usbReadFlash, [256, 16], "FFFF FFFF FFFF FFFF FFFF FFFF FFFF FFFF");
                await this.printTest("Quick Flash Memory Test", "Get current file number",this.usbGetFileNumber, [], 0xFFFFFFFF);
                await this.printTest("Quick Flash Memory Test", "Open new file",this.usbOpenFile, [], true);
                await this.printTest("Quick Flash Memory Test", "Check new file number",this.usbGetFileNumber, [], 0x0);

                let fileContent = "55 AA 01 01 03 FE FF 00 AB CD EF 12 34 56 78 90 00 FF FE";
                let expectedHeader = "00 00 00 00 FE FF";
                let readLen = hexLen(expectedHeader + fileContent);
                await this.printTest("Quick Flash Memory Test", "Write to new file",this.usbWriteFile, [hex2buf(fileContent)], true);
                await this.printTest("Quick Flash Memory Test", "Memory read to check file write occured",this.usbReadFlash, [0, readLen], expectedHeader + fileContent);

                let fileChunk = "AA 12 34 56 78 90 AB CD EF"
                await this.printTest("Quick Flash Memory Test", "Append to open file",this.usbWriteFile, [hex2buf(fileChunk)], true);
                fileContent += fileChunk
                readLen = hexLen(expectedHeader + fileContent);
                await this.printTest("Quick Flash Memory Test", "Memory read to check append occured",this.usbReadFlash, [0, readLen], expectedHeader + fileContent);

                fileChunk = "AA 12 34 56 78 90 AB CD EF"
                while (hexLen(fileChunk + fileContent) < 300){
                    fileChunk += "FE DC BA 09 87 65 43 21"
                }
                await this.printTest("Quick Flash Memory Test", "Append to open file, spanning page boundary",this.usbWriteFile, [hex2buf(fileChunk)], true);
                fileContent += fileChunk
                let fileContentClean = cleanHexString(fileContent); // to facilitate splitting
                let expectedHeader1 = "00 00 00 00 FE FA";
                let expectedHeader2 = "00 00 00 00 FF FF";
                readLen = hexLen(expectedHeader1 + expectedHeader2 + fileContent);
                let flashContent = expectedHeader1 + fileContentClean.substr(0,500) + expectedHeader2 + fileContentClean.substr(500, fileContentClean.length-500);
                await this.printTest("Quick Flash Memory Test", "Memory read to check append occured correctly",this.usbReadFlash, [0, readLen], flashContent);

                await this.printTest("Quick Flash Memory Test", "Check file size is reported correctly",this.usbGetCurrentFileSize, [], hexLen(fileContent));

                await this.printTest("Quick Flash Memory Test", "Close file",this.usbCloseFile, [], true);
                await this.printTest("Quick Flash Memory Test", "Check file number is now invalid",this.usbGetFileNumber, [], 0xFFFFFFFF);

                expectedHeader2 = "00 00 00 00 FF 33";
                let fileContent2 =  fileContentClean.substr(500, fileContentClean.length-500);
                readLen = hexLen(expectedHeader2 + fileContent2);
                await this.printTest("Quick Flash Memory Test", "Memory read to check file close occured correctly",this.usbReadFlash, [256, readLen], expectedHeader2 + fileContent2);

                await this.printTest("Quick Flash Memory Test", "Check flash address is correct for new file",this.usbGetFlashAddress, [], 512);

                await this.printTest("Quick Flash Memory Test", "Read file and compare file contents",this.usbReadFile, [0,0,fileContentClean.length], fileContentClean);
                await this.printTest("Quick Flash Memory Test", "Read partial file and check length",this.usbReadFile, [0,0,fileContentClean.length/2 - 50], fileContentClean.slice(0, fileContentClean.length - 100));

                await this.createAndVerifyFiles("Verify behaviour single large file", [65537*250], {byteSizeToCompare:[65535*250]});

                await this.printTest("Full Flash Memory Test", "Memory erase before further testing", this.usbResetFileSystem, [], true, "Clearing the flash memory takes 30 seconds, please wait");

                // verify 100 random sized test files
                let fileSizeList = []
                for (let i=0; i<100; i++){
                    fileSizeList.push(randomInt(0, 32768));
                }
                await this.createAndVerifyFiles("Verify behaviour with " + fileSizeList.length + " random sized files", fileSizeList)

                // get the file size of the last file that was written (should still be open)
                await this.printTest("Full Flash Memory Test", "Check open file size", this.usbGetCurrentFileSize, [], fileSizeList[fileSizeList.length - 1]);

                // perform a couple of open/close operations to verify that
                // file numbers are not discarded.
                await this.printTest("Full Flash Memory Test", "Close files", this.usbCloseFile, [], true);
                await this.printTest("Full Flash Memory Test", "Open new file", this.usbOpenFile, [], true);
                await this.printTest("Full Flash Memory Test", "Reopen (closing empty file)", this.usbOpenFile, [], true);
                await this.printTest("Full Flash Memory Test", "Reopen (closing empty file)", this.usbOpenFile, [], true);
                await this.printTest("Full Flash Memory Test", "Close empty file", this.usbCloseFile, [], true);



                await this.printTest("Full Flash Memory Test", "Check file number range is correctly reported.", this.usbGetFileRange, [], [0, fileSizeList.length - 1]);

                await this.createAndVerifyFiles("Verify behaviour with 6 x 3MB files (which overflow flash)",
                    [3*1024*1024, 3*1024*1024, 3*1024*1024, 3*1024*1024, 3*1024*1024, 3*1024*1024],{indicesToTest:[1,2,3,4,5]});

                if (! this.hasFail){
                    this.results.push("<br>");
                    this.results.push(`<span class="pass mdi mdi-check-bold"> All tests successfully completed</span>`);
                }


            } catch(ex) {
                this.results.push(`<span class="fail">Exception in top level test code:"${ex}"</span>`);
                this.errorThrown = false;
            }


            this.blockErrors = false; // restore error detection.

        },
        onClearFlash(){
          this.clearFlashFiles(this.usbClearFiles, "Erase flash memory (keeping file number)");
        },
        onResetFileSystem(){
          this.clearFlashFiles(this.usbResetFileSystem, "Erase flash memory and reset file numbers");
        },
        async clearFlashFiles(proc, comment){

            this.hasFail = false; // clear flag so that tests are actually completed.
            this.results = []; // clear results

            try{
                await this.printTest(this.testLevel, comment, proc, [], true, "Clearing the flash memory takes 30 seconds, please wait");

                if (! this.hasFail){
                    this.results.push("<br>");
                    this.results.push(`<span class="pass mdi mdi-check-bold"> Operation successfully completed</span>`);
                }


            } catch(ex) {
                this.results.push(`<span class="fail">Exception in top level test code:"${ex}"</span>`);
                this.errorThrown = false;
            }

        }
    },
    watch:{
    },
    updated: function () {
        this.$nextTick(function () {
            // Code that will run only after the
            // entire view has been re-rendered
            //window.scrollTo(0, document.body.scrollHeight || document.documentElement.scrollHeight);
        });
    },
};
</script>

<style lang="stylus">
.fail
    color red
    font-weight bold
.pass
    color green
.wait
    color orange

</style>
